import type { NavigateFunction } from 'react-router-dom';

export const navigateFromSpotlight = (
  navigate: NavigateFunction,
  href: string,
) => {
  navigate(href);
};